export const GET_DEFAULT_SEARCH_START = 'DEFAULT/GET_DEFAULT_SEARCH_START';
export const GET_DEFAULT_SEARCH_SUCCESS = 'DEFAULT/GET_DEFAULT_SEARCH_SUCCESS';
export const GET_DEFAULT_SEARCH_ERROR = 'DEFAULT/GET_DEFAULT_SEARCH_ERROR';
